import { STICKERS } from "../../assets/media/stickers";
import TgSticker from "../sticker/TgSticker";
import "./Empty.scss";

function Empty() {
    return (
        <div className="empty-wrapper">
            <div className="sticker"><TgSticker src={STICKERS.duck_dont_know} loop={false} /></div>
            <span>Здесь пока пусто.</span>
        </div>
    );
};

export default Empty;